export const formatDateToQueryParam = (date: string) =>
  `${new Date(date).getFullYear()}-${new Date(date).toLocaleDateString(
    "pt-BR",
    {
      month: "2-digit",
    }
  )}`;
